export const USER_GET = '@USER_GET'
export const USER_GET_SUCCESS = '@USER_GET_SUCCESS'
export const USER_GET_FAILURE = '@USER_GET_FAILURE'
export const USER_SET_PROFILE_PREFERENCES = '@USER_SET_PROFILE_PREFERENCES'
export const USER_SET_PROFILE_PREFERENCES_SUCCESS = '@USER_SET_PROFILE_PREFERENCES_SUCCESS'
export const USER_SET_PROFILE_PREFERENCES_FAILURE = '@USER_SET_PROFILE_PREFERENCES_FAILURE'

export default {
  USER_GET,
  USER_GET_SUCCESS,
  USER_GET_FAILURE,
  USER_SET_PROFILE_PREFERENCES,
  USER_SET_PROFILE_PREFERENCES_SUCCESS,
  USER_SET_PROFILE_PREFERENCES_FAILURE
}
